import React from 'react';
import { Link } from 'react-router-dom';
import { 
  ChartBarIcon, 
  HeartIcon, 
  UserGroupIcon, 
  CurrencyDollarIcon,
  ClockIcon
} from '@heroicons/react/24/outline';

const Reports: React.FC = () => {
  const reports = [
    {
      title: 'Dress Likes Report',
      description: 'View dress popularity metrics from catalog browsing and Style Matcher',
      icon: HeartIcon,
      link: '/reports/likes',
      color: 'bg-red-100 text-red-600'
    },
    {
      title: 'Customer Activity',
      description: 'Track customer engagement and browsing patterns',
      icon: UserGroupIcon,
      link: '/reports/customers',
      color: 'bg-blue-100 text-blue-600',
      comingSoon: true
    },
    {
      title: 'Sales Analytics',
      description: 'Monitor sales performance and revenue trends',
      icon: CurrencyDollarIcon,
      link: '/reports/sales',
      color: 'bg-green-100 text-green-600',
      comingSoon: true
    },
    {
      title: 'Style Matcher Insights',
      description: 'Analyze Style Matcher usage and preferences',
      icon: ClockIcon,
      link: '/reports/style-matcher',
      color: 'bg-purple-100 text-purple-600',
      comingSoon: true
    }
  ];

  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">Reports</h1>
          <p className="mt-2 text-sm text-gray-700">
            Access analytics and insights about your business performance.
          </p>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {reports.map((report) => (
          <div
            key={report.title}
            className={`relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm hover:border-gray-400 ${
              report.comingSoon ? 'opacity-60' : ''
            }`}
          >
            {report.comingSoon ? (
              <div className="cursor-not-allowed">
                <div className="flex items-center">
                  <div className={`flex h-10 w-10 items-center justify-center rounded-md ${report.color}`}>
                    <report.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-gray-900">{report.title}</h3>
                    <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800">
                      Coming Soon
                    </span>
                  </div>
                </div>
                <p className="mt-2 text-sm text-gray-500">{report.description}</p>
              </div>
            ) : (
              <Link to={report.link} className="focus:outline-none">
                <div className="flex items-center">
                  <div className={`flex h-10 w-10 items-center justify-center rounded-md ${report.color}`}>
                    <report.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <h3 className="ml-4 text-lg font-medium text-gray-900">{report.title}</h3>
                </div>
                <p className="mt-2 text-sm text-gray-500">{report.description}</p>
                <div className="mt-3">
                  <span className="text-sm font-medium text-indigo-600 hover:text-indigo-500">
                    View report →
                  </span>
                </div>
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;